import { createSelector } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { AppState } from 'app/interfaces/store';
import { TournamentActivityState } from './interfaces';

const tournamentActivityState = (state: AppState): TournamentActivityState =>
  state[EntityStoreName.TournamentActivity];

const activitySelector = createSelector(
  tournamentActivityState,
  (state: TournamentActivityState) => state.entity
);

const nameSelector = createSelector(
  tournamentActivityState,
  (state: TournamentActivityState) => state.entity.tournament?.name ?? ''
);

const timerDurationSelector = createSelector(
  tournamentActivityState,
  (state: TournamentActivityState) => state.entity.activity?.duration ?? 0
);

const timerStartedAtSelector = createSelector(
  tournamentActivityState,
  (state: TournamentActivityState) => state.entity.activity?.startedAt ?? ''
);

export const tournamentActivitySelector = {
  activity: activitySelector,
  name: nameSelector,
  timerStartedAt: timerStartedAtSelector,
  timerDuration: timerDurationSelector,
};
